<template>
    <ob1-search-field
        id="search-field"
        v-model="value"
        :label="placeHolder"
        :show-auto-completion="showAutoCompletion"
        :tms-button-category="tmsCategory"
        :tms-button-action="tmsButtonAction"
        :tms-button-label="computeTmsLabel()"
        :tms-result-category="tmsCategory"
        :tms-result-action="tmsResultAction"
        :tms-result-label="computeTmsLabel()"
        @input="inputSearchFiledHandler"
    />
</template>

<script>
import {algoliasearch} from "algoliasearch";

export default {
    props: {
        placeHolder: {
            type: String,
            default: ""
        },
        searchResultsUrl: {
            type: String,
            required: true
        },
        searchResultsQueryAdditionalParams: {
            type: String,
            required: true
        },
        algoliaAppId: {
            type: String,
            required: true
        },
        algoliaApiKey: {
            type: String,
            required: true
        },
        algoliaIndexName: {
            type: String,
            required: true
        },
        tmsCategory: {
            type: String,
            default: null
        },
        tmsButtonAction: {
            type: String,
            default: null
        },
        tmsResultAction: {
            type: String,
            default: null
        },
        enableSearchAlgolia: {
            type: Boolean,
            default: false
        },
        deviceListSearchUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            value: "",
            responseList: [""], // astuce pour ne pas afficher d'erreur avant la saisie de 3 caractères
            showAutoCompletion: false
        }
    },
    mounted: function () {
        this.searchFieldHandler();
        this.prefillFromUrl();
    },
    methods: {
        computeTmsLabel() {
            return this.tmsCategory ? this.value.trim().replace(/\s+/g, "") : null;
        },
        searchFieldHandler() {
            const searchFieldButton = document.getElementById('search-field-button')
            const searchField = document.getElementById('search-field')
            searchFieldButton.addEventListener('click', this.launchSearch);
            searchField.addEventListener('keyup', (event) => {
                if (event.key === 'Enter') {
                    this.showAutoCompletion = false;
                    this.launchSearch();
                }
            });
        },
        inputSearchFiledHandler(value) {
            const elt = document.querySelector("#search-field");
            if (!elt) {
                return;
            }
            const searchField = ob1.Ob1Component.get(elt).SearchField;
            if (!searchField) {
                return;
            }
            searchField.repository = this.responseList;
            this.showAutoCompletion = false
            if (value.length >= 3) {
                const client = algoliasearch(this.algoliaAppId, this.algoliaApiKey);
                const indexName = this.algoliaIndexName;
                client.search({
                    requests: [
                        {
                            indexName: indexName,
                            query: value,
                            hitsPerPage: 5
                        },
                    ],
                }).then((results) => {
                        if (results.results && results.results.length > 0) {
                            this.responseList = results.results[0].hits.map(hit => hit.query);
                            if (this.responseList.length === 0) {
                                this.responseList = [""]; // astuce pour ne pas afficher d'erreur en cas de liste vide
                            }
                            searchField.repository = this.responseList;
                            elt.dispatchEvent(new Event("keyup")); // on force la resynchronisation avec le js ob1
                            if (this.responseList.length === 1) {
                                this.showAutoCompletion = this.responseList[0].length !== 0;
                            } else {
                                this.showAutoCompletion = this.responseList.length !== 0;
                            }
                        }
                    }
                ).catch(() => {
                    this.responseList = [""];
                })
            }
        },
        launchSearch() {
            const searchField = document.getElementById('search-field');
            if (!searchField || !searchField.value.trim()) {
                return;
            }
            this.value = searchField.value.trim();
            if (this.enableSearchAlgolia) {
                document.location.href =
                    this.deviceListSearchUrl + encodeURIComponent(this.value)
            } else {
                document.location.href =
                    this.searchResultsUrl +
                    '/?kw=' + encodeURIComponent(this.value) +
                    this.searchResultsQueryAdditionalParams;
            }
        },
        prefillFromUrl() {
            // recherche back : /search/{textSearch}
            //Préremplir le champ de saisie avec le param qui se trouve dans l'url
            const match = window.location.pathname.match(/\/search\/([^/?#]+)/);
            if (!match) {
                return;
            }
            const term = decodeURIComponent(match[1]);
            this.value = term;
            const searchField = document.getElementById('search-field');
            if (searchField) {
                searchField.value = term;
            }
        },
    }
}
</script>
